var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2916 10.8753V9.12533H23.6666V10.8753H19.2916ZM20.7499 19.3337L17.2208 16.7087L18.2708 15.3087L21.7999 17.9337L20.7499 19.3337ZM18.3583 4.66283L17.3083 3.26283L20.7499 0.666992L21.7999 2.06699L18.3583 4.66283ZM4.12492 18.167V13.5003H2.08325C1.59714 13.5003 1.18395 13.3302 0.843669 12.9899C0.503391 12.6496 0.333252 12.2364 0.333252 11.7503V8.25033C0.333252 7.76421 0.503391 7.35102 0.843669 7.01074C1.18395 6.67046 1.59714 6.50033 2.08325 6.50033H7.33325L13.1666 3.00033V17.0003L7.33325 13.5003H5.87492V18.167H4.12492ZM14.3333 13.9087V6.09199C14.8583 6.55866 15.2812 7.12741 15.602 7.79824C15.9228 8.46908 16.0833 9.2031 16.0833 10.0003C16.0833 10.7975 15.9228 11.5316 15.602 12.2024C15.2812 12.8732 14.8583 13.442 14.3333 13.9087ZM2.08325 8.25033V11.7503H7.79992L11.4166 13.9087V6.09199L7.79992 8.25033H2.08325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.7ba575b05f8f7cde25120ecb7a8add63.svg";
export { ForwardRef as ReactComponent };